import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast';
import { updateWallet } from 'services/apiUserCreditManagement';

const useUpdateWallet = () => {
  const queryClient = useQueryClient();
  const{isPending:isUpdating,isSuccess:isUpdated,mutate: updateUserWallet}=useMutation({
    mutationFn: updateWallet,
    onSuccess:(data)=>{
        queryClient.setQueryData(['updatedUserWallet'],data)
        queryClient.invalidateQueries({queryKey:['usersCredits']})
        toast.success("Wallet Updated Successfully",{id:"wallet-update"})
    },
    onError:(error)=>{
        console.log("Error occurred while updating wallet",error)
        if(error?.data && typeof error.data === 'object'){
            for (const key in error.data){
                const msg = error.data[key];
                toast.error(Array.isArray(msg) ? msg[0] : msg,{id:"wallet-update"})
            }
        }else{
            toast.error(error.message || "Something went wrong",{id:"wallet-update"})
        }
    }
  })

  return{isUpdating,isUpdated,updateUserWallet}
}

export default useUpdateWallet
